import { Instagram, Linkedin } from "lucide-react";

const TikTokIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" />
  </svg>
);

const SOCIALS = [
  { id: "instagram", label: "Instagram", href: "https://www.instagram.com/xsalesconsultingl.td", Icon: Instagram },
  { id: "linkedin", label: "LinkedIn", href: "https://www.linkedin.com/company/xsales-consulying-ltd/", Icon: Linkedin },
  { id: "tiktok", label: "TikTok", href: "https://www.tiktok.com/@xsalesconsulting", Icon: TikTokIcon },
];

const SocialLinks = ({ className = "" }) => (
  <div className={`flex items-center gap-3 ${className}`} data-testid="social-links">
    {SOCIALS.map(({ id, label, href, Icon }) => (
      <a
        key={id}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={`XSALES Consulting su ${label}`}
        data-testid={`social-${id}-link`}
        className="w-10 h-10 rounded-full border border-white/15 flex items-center justify-center text-white/60 hover:text-neon-cyan hover:border-neon-cyan/60 hover:shadow-[0_0_18px_rgba(0,229,255,0.25)] transition-all duration-300"
      >
        <Icon size={17} />
      </a>
    ))}
  </div>
);

export default SocialLinks;
